import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResellerModeService {
  private resellerModeActive = new BehaviorSubject<boolean>(false);
  private resellerAvailable = new BehaviorSubject<boolean>(false);

  constructor(private router: Router) {
    // Initialize based on current URL (in case of reload)
    this.updateModeFromUrl(this.router.url);

    // Keep mode in sync with navigation
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateModeFromUrl(event.urlAfterRedirects || event.url);
      });
  }

  setMode(active: boolean) {
    this.resellerModeActive.next(active);
  }

  getIsActive() {
    return this.resellerModeActive.asObservable();
  }

  // Availability flag is used to control UI (arrow/menu visibility) without forcing navigation
  setAvailable(available: boolean) {
    this.resellerAvailable.next(available);
  }

  getIsAvailable() {
    return this.resellerAvailable.asObservable();
  }

  private updateModeFromUrl(url: string) {
    const path = (url || '').split('?')[0];
    const isReseller = path.startsWith('/reseller');
    this.setMode(isReseller);
  }
}
